import React, {useRef} from "react";
import {
    Divider,
    LinearProgress,
    Typography
} from "@material-ui/core";
import ReactToPrint from "react-to-print";
import TMSearchResultItem from "./TMSearchResultItem";
const domain = window.location.host;
let iplf = false
let knk = false
if(domain.includes('ipandlegalfilings')){
    iplf=true
}
if(domain.includes('khuranaandkhurana')){
    knk=true
}

const TMSearchResults = ({trademarks, loading, count, searchedWordmark, offset, openDetail, onLoadMore}) => {
    const trademarks_box = useRef()
    return (
        <div className="w-full bg-white shadow flex flex-col">
            {searchedWordmark !== "" && (
                <div className="flex flex-row p-4">
                    <Typography className="text-gray-500 flex-1">Search results for "{searchedWordmark}"
                        : <span className='font-medium'>{count} trademarks</span></Typography>
                    <ReactToPrint
                        trigger={() => {
                            return <Typography component={'a'} href='#' color={"primary"}>Generate PDF
                                Report</Typography>;
                        }}
                        content={() => trademarks_box.current}
                    />

                </div>
            )}
            {count === 0 && searchedWordmark !== "" && (
                <Typography className="text-gray-500 flex-1 text-center p-4">No Results Found</Typography>
            )}


            <div ref={trademarks_box}>
                {trademarks && trademarks.map((item, index) => (
                    <div key={item.application_number}>
                        {(index > 0 && (trademarks[index - 1].class !== item.class)) &&
                        <p
                            className='self-start w-24 text-center text-white px-2 mt-4 text-sm caption uppercase'
                            style={{backgroundColor: iplf?'#5E6EE7':'#AB5212'}}>
                            Class {item.class}
                        </p>}

                        {index === 0 &&
                        <p
                            className='self-start w-24 text-center text-white px-2 mt-4 text-sm caption uppercase'
                            style={{backgroundColor: iplf?'#5E6EE7':'#AB5212'}}>
                            Class {item.class}
                        </p>}
                        <Divider/>
                        <TMSearchResultItem trademark={item} openDetail={openDetail}/>
                    </div>
                ))}
            </div>

            {count > offset && (
                <div className='h-12 flex flex-col'>
                    <div className='flex-1'/>
                    {count > offset && !loading &&
                    <p
                        onClick={onLoadMore}
                        className='text-center p-2 text-sm caption text-white uppercase cursor-pointer'
                        style={{backgroundColor: iplf?'#5E6EE7':'#AB5212'}}>
                        Load More
                    </p>
                    }
                    {count > offset && loading && <LinearProgress className='bottom-0'/>}
                </div>
            )}
        </div>
    )
}

export default TMSearchResults;